import {styled} from "@mui/material/styles";
import StepConnector, {stepConnectorClasses} from "@mui/material/StepConnector";
import {StepIconProps} from "@mui/material/StepIcon";
import * as React from "react";
import Check from "@mui/icons-material/Check";
import {AccountCircle, AttachMoney, UploadFileSharp} from "@mui/icons-material";
import Paper from "@mui/material/Paper";

export const renderTypeIdentificationDescription = (type: string): string => {
    switch (type) {
        case "4":
            return "TARJETA DE IDENTIDAD"
        case "1":
        case "13":
            return "CEDULA"
        case "22":
            return "CEDULA EXTRANJERIA"
        case "2":
            return "NIT"
        case "5":
        case "41":
            return "PASAPORTE"
        default:
            return ""
    }
}

export const ColorlibConnector = styled(StepConnector)(({theme}) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 16,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: '#076a61',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: '#4FAE32',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#b0b0b0',
        borderRadius: 1,
    },
}));

export const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
}>(({theme, ownerState}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#b0b0b0',
    zIndex: 1,
    color: '#fff',
    width: '35px',
    height: '35px',
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        backgroundColor: '#076a61',
        boxShadow: '0 0 0 3px rgba(7, 106, 97, 0.3)',
    }),
    ...(ownerState.completed && {
        backgroundColor: '#4FAE32',
    }),
}));

export const Item = styled(Paper)(({theme}) => ({
    padding: theme.spacing(4),
    textAlign: 'center',
}));


